// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kangaskhan: PokeData = {
  "id": 115,
  "name": "kangaskhan",
  "height": 22,
  "weight": 800,
  "base_experience": 172,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "pound",
    "comet-punch",
    "mega-punch",
    "stomp",
    "headbutt",
    "tail-whip",
    "leer",
    "bite",
    "growl",
    "rage",
    "focus-energy",
    "dizzy-punch",
    "reversal",
    "outrage",
    "endure",
    "crunch",
    "fake-out",
    "last-resort",
    "sucker-punch",
    "double-hit",
    "chip-away"
  ],
  "moves": [
    "headbutt",
    "leer",
    "bite",
    "growl",
    "outrage",
    "crunch",
    "protect",
    "tackle",
    "quick-attack",
    "tri-attack",
    "scary-face",
    "supersonic",
    "body-slam"
  ],
  "evolution_chain": {
    "id": 53,
    "item": null,
    "species": [
      {
        "name": "kangaskhan",
        "order": 131,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 130,
    "ability_power": 137
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
